import { distributionPlatforms } from "../../../mocks/platformData";

const distFeatures = [
  { icon: "ri-speed-line", title: "즉시 내보내기", desc: "스트림이 종료되는 순간 클립이 내보내지고 배포 대기열에 등록됩니다. 수동 작업이 필요 없습니다." },
  { icon: "ri-global-line", title: "멀티 플랫폼 배포", desc: "플랫폼별 메타데이터와 함께 TikTok, YouTube Shorts, Instagram Reels에 동시 배포합니다." },
  { icon: "ri-time-line", title: "타이밍 최적화", desc: "AI가 각 플랫폼과 지역별 최고 참여 시간대에 자동으로 게시를 예약합니다." },
  { icon: "ri-refresh-line", title: "성과 피드백", desc: "클립 성과 데이터가 감지 모델에 자동 반영되어 매 스트림마다 더 똑똑해집니다." },
];

const recentActivity = [
  { clip: "종교 탈출 고백 – 핵심 발언", platform: "YouTube Shorts", time: "2분 전", views: "142K", status: "published" },
  { clip: "예상 밖 반전 순간 – 스튜디오 반응", platform: "TikTok", time: "8분 전", views: "89K", status: "published" },
  { clip: "시사 인터뷰 논점 폭발 구간", platform: "Instagram Reels", time: "14분 전", views: "67K", status: "published" },
  { clip: "국보급 발언 명장면", platform: "TikTok", time: "22분 전", views: "310K", status: "viral" },
];

const platformColors: Record<string, string> = {
  TikTok: "#10B981",
  "YouTube Shorts": "#EF4444",
  "Instagram Reels": "#F59E0B",
};

const platformIcons: Record<string, string> = {
  TikTok: "ri-tiktok-fill",
  "YouTube Shorts": "ri-youtube-fill",
  "Instagram Reels": "ri-instagram-fill",
};

export default function DistributionSection() {
  return (
    <section className="py-28 bg-[#0A0E14] relative overflow-hidden">
      <div className="absolute bottom-0 left-1/3 w-80 h-80 rounded-full bg-[#10B981]/5 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#10B981] text-xs font-semibold uppercase tracking-widest mb-4 block" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
            05 / 배포 및 분석
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-5" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            방송에서 <span className="text-[#10B981]">전 세계로</span> — 즉시
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
            에피소드 분석이 완료되는 즉시 클립이 배포됩니다. 방송 종료 후 몇 분 안에
            숏폼이 업로드되어 타이밍 기반 바이럴 효과를 극대화합니다.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 mb-12">
          {distributionPlatforms.map((p) => (
            <div key={p.name} className="bg-[#0F1419] border border-white/8 rounded-2xl p-7 hover:border-[#10B981]/20 transition-all duration-300 cursor-pointer group">
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl" style={{ backgroundColor: `${p.color}15` }}>
                    <i className={`${p.icon} text-xl`} style={{ color: p.color }} />
                  </div>
                  <span className="text-white font-semibold" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{p.name}</span>
                </div>
                <span className="flex items-center gap-1.5 text-xs text-[#10B981]" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                  <span className="w-1.5 h-1.5 rounded-full bg-[#10B981] animate-pulse inline-block" />
                  라이브
                </span>
              </div>
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div>
                  <div className="text-2xl font-bold mb-1" style={{ color: p.color, fontFamily: "'JetBrains Mono', monospace" }}>{p.clips}</div>
                  <div className="text-gray-500 text-xs">게시된 클립</div>
                </div>
                <div>
                  <div className="text-2xl font-bold mb-1" style={{ color: p.color, fontFamily: "'JetBrains Mono', monospace" }}>{p.reach}</div>
                  <div className="text-gray-500 text-xs">총 도달률</div>
                </div>
              </div>
              <div className="h-1.5 bg-[#1A1F2E] rounded-full overflow-hidden">
                <div className="h-full rounded-full" style={{ width: "78%", backgroundColor: p.color }} />
              </div>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          <div className="space-y-4">
            {distFeatures.map((f) => (
              <div key={f.title} className="flex items-start gap-4 bg-[#0F1419] border border-white/8 rounded-xl p-5">
                <div className="w-10 h-10 flex items-center justify-center bg-[#10B981]/10 rounded-xl shrink-0">
                  <i className={`${f.icon} text-[#10B981] text-lg`} />
                </div>
                <div>
                  <div className="text-white font-semibold mb-1 text-sm" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{f.title}</div>
                  <p className="text-gray-500 text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-[#0F1419] border border-white/8 rounded-2xl overflow-hidden">
            <div className="flex items-center justify-between px-6 py-4 border-b border-white/8">
              <span className="text-white font-semibold text-sm" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>최근 배포 현황</span>
              <span className="text-gray-500 text-xs cursor-pointer hover:text-gray-300">전체 보기</span>
            </div>
            <div className="divide-y divide-white/5">
              {recentActivity.map((item, i) => (
                <div key={i} className="flex items-center gap-4 px-6 py-4">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg shrink-0" style={{ backgroundColor: `${platformColors[item.platform]}15` }}>
                    <i className={`${platformIcons[item.platform]} text-sm`} style={{ color: platformColors[item.platform] }} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-white text-sm font-medium truncate" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{item.clip}</div>
                    <div className="text-gray-500 text-xs">{item.platform} · {item.time}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-white text-sm font-bold" style={{ fontFamily: "'JetBrains Mono', monospace" }}>{item.views}</div>
                    <span className={`text-xs ${item.status === "viral" ? "text-[#F59E0B]" : "text-[#10B981]"}`} style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                      {item.status === "viral" ? "🔥 바이럴" : "✓ 게시됨"}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
